(() => {
    "use strict";

    document.addEventListener("DOMContentLoaded", () => {
        // Header Menu
        setTimeout(() => {
            document.querySelectorAll("#header-main .elementor-nav-menu > .menu-item > .has-submenu").forEach((item) => {
                item.addEventListener("click", (e) => {
                    const link = e.target.closest("a");
                    if (link && link.getAttribute("href") === "#") {
                        e.preventDefault();
                    }
                });
            });
        }, 1000);

        // Stats Section
        function animateNumber(element, targetString) {
            // Convert European format to number (replace . with empty string for thousands separator)
            const targetValue = parseInt(targetString.replace(/\./g, ""), 10);

            // Skip animation if not a valid number
            if (isNaN(targetValue)) return;

            const duration = 1000; // 1 second
            const startTime = Date.now();
            const startValue = 0;

            function updateNumber() {
                const elapsed = Date.now() - startTime;
                const progress = Math.min(elapsed / duration, 1);

                // Use easing function for smooth animation (ease-out)
                const easeOut = 1 - Math.pow(1 - progress, 3);

                const currentValue = Math.round(startValue + (targetValue - startValue) * easeOut);

                // Format number with European thousands separator (dot)
                const formattedNumber = currentValue.toLocaleString("ro-RO");

                element.textContent = formattedNumber;

                if (progress < 1) {
                    requestAnimationFrame(updateNumber);
                }
            }

            // Start the animation
            requestAnimationFrame(updateNumber);
        }

        // Set up Intersection Observer for number animation
        const observerOptions = {
            threshold: 0.5, // Trigger when 50% of element is visible
            rootMargin: "0px 0px -50px 0px", // Start animation slightly before element is fully in view
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const span = entry.target;
                    const numar = span.dataset.originalValue || span.textContent;

                    // Store original value if not already stored
                    if (!span.dataset.originalValue) {
                        span.dataset.originalValue = span.textContent;
                    }

                    animateNumber(span, numar);
                    observer.unobserve(span); // Only animate once
                }
            });
        }, observerOptions);

        document.querySelectorAll("#stats-sec .elementor-heading-title span").forEach((span) => {
            // Store original value and set to 1 on page load
            span.dataset.originalValue = span.textContent;
            span.textContent = "1";
            observer.observe(span);
        });

        // Intro Section
        // document.querySelectorAll("#intro-sec .elementor-inner-section .elementor-widget-button").forEach((button) => {
        //     const parent = button.parentNode;
        //     const wrapper = document.createElement("a");
        //     wrapper.classList.add("link-tratament");
        //     wrapper.href = button.querySelector("a").href;
        //     parent.parentNode.insertBefore(wrapper, parent);
        //     wrapper.appendChild(parent);
        // });
    });
})();
